import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

import { setupLayouts } from 'virtual:generated-layouts'
import { template } from 'cypress/types/lodash'
import {getAuth, onAuthStateChanged} from "firebase/auth"
import generatedRoutes from 'virtual:generated-pages'

import { type IStaticMethods } from "preline/preline";
import creator from './pages/creator.vue'
declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
  }
}

const routes = setupLayouts(generatedRoutes)

console.log(setupLayouts(generatedRoutes))


// const routes = [
//   { path: '/creator', component: creator },
// ]
const router = createRouter({
  history: createWebHistory(),
  routes
})
router.afterEach((to, from, failure) => {
  if (!failure) {
    setTimeout(() => {
      window.HSStaticMethods.autoInit();
    }, 100)
  }
});

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    )
  })
};


router.beforeResolve(async (to, from, next) => {
  console.log("LOG LOG ")
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (await getCurrentUser()) {
      next();
    }
    else {
      alert("You don't have access!")
      next("/")
    }
  }
  else {
    next()
  }
})

export default router
